import React from "react";
import GenericCRUD from "@/components/common/GenericCRUD";

const config = {
  resource: "faqs",
  singular: "FAQ",
  title: "FAQ",
  subtitle: "Frequently asked questions.",
  titleKey: "question",
  columns: [
    { key: "question", label: "Question", render: (r) => <span className="text-white font-medium max-w-lg block truncate">{r.question}</span> },
    { key: "category", label: "Category" },
    { key: "order", label: "Order", className: "w-20" },
    { key: "visible", label: "Visible", render: (r) => r.visible ? "Yes" : "No" },
  ],
  fields: [
    { key: "question", label: "Question", type: "text" },
    { key: "answer", label: "Answer", type: "textarea" },
    { key: "category", label: "Category", type: "text" },
    { key: "order", label: "Order", type: "number" },
    { key: "visible", label: "Visible", type: "switch" },
  ],
  defaultValues: { visible: true, order: 0 },
};

export default function FAQ() { return <GenericCRUD config={config} />; }
